module.exports = __webpack_public_path__ + "img/icon_map_6_c.4219fb2e.png";